import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { PermissionDTO } from '../../../interfaces/permission.interface';
import { RolesService } from '../../../services/roles.service';
import { RegisterRoleRequest } from '../../../interfaces/roles.interfaces';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-new-role-modal',
  templateUrl: './register-new-role-modal.component.html',
  styleUrls: ['./register-new-role-modal.component.scss']
})
export class RegisterNewRoleModalComponent implements OnInit {

  public permissions$: Observable<Array<PermissionDTO>>;

  public registerRole: FormGroup;
  constructor(private dialogRef: MatDialogRef<RegisterNewRoleModalComponent>,
  private fb: FormBuilder,
  private roleService: RolesService)
  {
    this.permissions$ = new Observable<Array<PermissionDTO>>;
    this.registerRole = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
      description: ['', Validators.required],
      permissions: [null]
    });
  }

  ngOnInit(): void {
    this.getPermissions();
  }

  getPermissions():void {
    this.permissions$ = this.roleService.getAllPermissions();
  }

  closeModal(): void {
    this.dialogRef.close(false);
  }

  public submitRegisterRole(): void {
    const {name, description, code, permissions} = this.registerRole.value;
    const request: RegisterRoleRequest = {
      roleName: name,
      roleCode: code,
      description: description,
      permissions: permissions
    };

    Swal.fire({
      text: 'Registrando rol',
      icon: 'info',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.sendRegisterRoleRequest(request);
      }
    });
  }

  private sendRegisterRoleRequest(request: RegisterRoleRequest){
    this.roleService.registerRole(request)
    .subscribe({
      next: (response) => {
        Swal.fire({
          text: response.resultMessage,
          icon: 'success',
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: 'Cerrar',

        }).then((r) => {
          this.dialogRef.close(true);
        })
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.resultMessage,
          icon: 'error',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar',
        })
      }
    })
  }


}
